const routes = [
  {
    path: '',
    component: () =>
      import('@/views/provider/visit-registration-calendar/Wrapper.vue'),
    children: [
      {
        path: '/provider/visit-registration-calendar',
        name: 'VisitRegistrationCalendar',
        component: () =>
          import('@/views/provider/visit-registration-calendar/Main.vue'),
      },
    ],
  },
];

export default routes;
